/* Persist the optional job reference before handing checkout to existing apps. */
(() => {
  let pending = Promise.resolve();
  const field = () => document.getElementById('zuma-reference');
  const status = message => {
    const node = document.getElementById('zuma-reference-status');
    if (node) node.textContent = message;
  };
  function save() {
    const input = field();
    if (!input) return Promise.resolve();
    const value = input.value;
    pending = pending.catch(() => {}).then(async () => {
      if (input.defaultValue === value) return;
      status('Saving reference…');
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes: {'Job reference': value}})
        });
        if (!response.ok) throw new Error('Save failed');
        const cart = await response.json();
        if ((cart.attributes?.['Job reference'] || '') !== value) throw new Error('Save not confirmed');
        input.defaultValue = value;
        status(value ? 'Reference saved.' : 'Reference cleared.');
      } catch (error) {
        status('Could not save your reference. Please try checkout again.');
        throw error;
      }
    });
    return pending;
  }
  document.addEventListener('change', event => {
    if (event.target.id === 'zuma-reference') save().catch(() => {});
  }, true);
  let replay = false;
  document.addEventListener('click', event => {
    const button = event.target.closest('#zuma-cart-form button[name="checkout"]');
    const input = field();
    if (!button || !input || replay || input.value === input.defaultValue) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    save().then(() => {
      replay = true;
      try { button.click(); } finally { replay = false; }
    }).catch(() => { input.focus(); });
  }, true);
  document.addEventListener('submit', event => {
    const input = field();
    if (event.target.id !== 'zuma-cart-form' || !input || replay || input.value === input.defaultValue) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter || event.target.querySelector('[name="checkout"]');
    save().then(() => {
      replay = true;
      try { button.click(); } finally { replay = false; }
    }).catch(() => { input.focus(); });
  }, true);
})();
